import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useSearchParams } from 'react-router-dom';
import {
    deleteMAGAD010,
    getMAGAA000,
    getMAGAD010,
    getMAGAD010gubun,
    postMAGAD010,
    postMAGAD010add,
    putMAGAA000,
    putMAGAD010,
} from '../../../services/Api';
import momentDate from '../../../shared/components/MomentDate';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';

registerLocale('ko', ko);

const MAGAD010 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const [data, setData] = useState([]);
    const [display, setDisplay] = useState('N');
    const [prepareData, setPrepareData] = useState([]);
    const [searchCondition, setSearchCondition] = useState('');
    const [keyword, setKeyword] = useState('');
    const [dateRate, setDateRate] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [isOpenDocument, setIsOpenDocument] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [gubunData, setGubunData] = useState([]);
    const [isAdd, setIsAdd] = useState(false);
    const [seq, setSeq] = useState('');

    const [file, setFile] = useState(null);
    const [fileImage, setFileImage] = useState(null);
    const fileInputRef = useRef(null);
    const fileImageInputRef = useRef(null);
    const [checkedList, setCheckedList] = useState([]);

    const freshDisplay = () => {
        getMAGAA000('pagai010')
            .then(({ data }) => {
                setDisplay(data.display);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        freshDisplay();
    }, []);

    const handleChangeDisplay = async (e) => {
        // const newDisplay = display === 'Y' ? 'N' : 'Y';
        try {
            await putMAGAA000('pagai010');
            freshDisplay();
        } catch (error) {
            console.log(error);
        }
    };

    const handleFileChange = (e) => {
        const name = e.target.name;
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            if (name === 'file') {
                setFile(selectedFile);
            } else if (name === 'fileImage') {
                setFileImage(selectedFile);
            }
            const preview = URL.createObjectURL(selectedFile);
            return () => {
                URL.revokeObjectURL(preview);
            };
        }
    };

    const handleRemoveFile = (fileType) => {
        if (fileType === 'file') {
            setFile(null);
        } else if (fileType === 'fileImage') {
            setFileImage(null);
        }
    };

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const handleDateRange = (e) => {
        const valueRangeDate = e.target.getAttribute('value-date-range');
        setDateRate(valueRangeDate);
        const today = moment().format('YYYY-MM-DD');
        const dateMoment = momentDate(today, valueRangeDate);
        setStartDate(dateMoment);
        setEndDate(today);
    };

    const handleDateChange = (date, name) => {
        setDateRate('');
        if (name === 'startDate') {
            setStartDate(date);
        } else if (name === 'endDate') {
            setEndDate(date);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPrepareData((prevData) => ({
            document: {
                ...prevData.document,
                [name]: value,
            },
        }));
    };

    const getListData = (currentPage = page) => {
        const startDateFormated = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormated = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postMAGAD010({
            page: currentPage,
            searchCondition,
            keyword: keyword?.trim(),
            startDate: startDateFormated,
            endDate: endDateFormated,
        })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handlePopupAdd = async (type) => {
        if (type !== 'add') {
            setPrepareData([]);
            setIsAdd(false);
        } else {
            setIsOpenDocument(true);
            setIsAdd(true);
        }
    };
    useEffect(() => {
        setPrepareData([]);
    }, [isAdd]);

    const handlePopupUpdate = async (e) => {
        handlePopupAdd('update');
        try {
            const seq = e.currentTarget.dataset.seq;
            const { data } = await getMAGAD010(seq);
            setPrepareData(data);
            setSeq(seq);
            setIsOpenDocument(true);
        } catch (error) {
            console.log(error);
        }
    };

    const handleCheckDelete = (seq, isChecked) => {
        setCheckedList((prevData) => {
            if (isChecked) {
                return [...prevData, seq];
            } else {
                return prevData.filter((item) => item !== seq);
            }
        });
    };

    const handleDelete = async () => {
        if (checkedList.length === 0) {
            window.alert('삭제할 항목을 선택해 주세요.');
            return;
        }

        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            for (const item of checkedList) {
                await deleteMAGAD010(item);
            }
            getListData();
            setCheckedList([]);
        }
    };

    const validateForm = (payload) => {
        if (!payload.title || !payload.gubun || !payload.attachFile || !payload.prevImg) {
            return false;
        }
        return true;
    };

    const handleSave = () => {
        const payload = {
            title: prepareData.document?.title || '',
            gubun: prepareData.document?.gubun || gubunData[0].code,
            attachFile: prepareData.document?.attachFile || file?.name || '',
            prevImg: prepareData.document?.prevImg || fileImage?.name || '',
        };

        if (!isAdd) {
            payload.seq = seq;
        }

        if (!validateForm(payload)) {
            window.alert(MESSAGE.notify.requireError);
            return;
        }

        const message = '등록/수정되었습니다.';
        if (window.confirm('등록/수정하시겠습니까?')) {
            const formData = new FormData();
            formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
            if (file) {
                formData.append('file', file);
            }
            if (fileImage) {
                formData.append('previewImg', fileImage);
            }

            if (isAdd) {
                postMAGAD010add(formData)
                    .then(() => {
                        handleClosePopup();
                        getListData();
                        window.alert(message);
                        setData({
                            title: '',
                            description: '',
                        });
                        setFileImage(null);
                        setPrepareData({});
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert('error create');
                    });
            } else {
                putMAGAD010(formData)
                    .then(() => {
                        handleClosePopup();
                        getListData();
                        window.alert(message);
                        setData({
                            title: '',
                            description: '',
                        });
                        setFileImage(null);
                        setPrepareData({});
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.notify.createError);
                    });
            }
        }
    };

    const handleClosePopup = () => {
        setIsOpenDocument(false);
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    };

    const clickReset = () => {
        setSearchParams('');
        setSearchCondition('MemberID');
        setKeyword('');
        setDateRate('');
        setStartDate('');
        setEndDate('');
    };

    useEffect(() => {
        getListData();
        getMAGAD010gubun()
            .then(({ data }) => {
                setGubunData(data);
            })
            .catch((error) => console.log(error));
        // eslint-disable-next-line
    }, [page]);

    return (
        <div className="container">
            <div className="list-notification wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="list-notification-content content-right">
                    <h1 className="title">문서서식</h1>
                    <div id="search-box">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>검색</th>
                                    <td>
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="001">이력서 관련 서식</option>
                                                <option value="002">인사노무 서식</option>
                                                <option value="">기타</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어 입력"
                                                onChange={inputChange}
                                                value={keyword}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>등록일</th>
                                    <td colSpan={3}>
                                        <div className="flex group-item">
                                            <div className="group-datepicker">
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={startDateRef}
                                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={startDate}
                                                        maxDate={endDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="start-date-icon"
                                                        onClick={() => startDateRef.current.setFocus()}
                                                    />
                                                </div>
                                                <span>~</span>
                                                <div className="datepicker-child">
                                                    <DatePicker
                                                        ref={endDateRef}
                                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                                        locale={'ko'}
                                                        placeholderText={'YYYY/MM/DD'}
                                                        dateFormat={'yyyy/MM/dd'}
                                                        selected={endDate}
                                                        minDate={startDate || null}
                                                    />
                                                    <i
                                                        className="icon icon-date"
                                                        id="end-date-icon"
                                                        onClick={() => endDateRef.current.setFocus()}
                                                    />
                                                </div>
                                            </div>
                                            <ul className="select-value">
                                                <li
                                                    value-date-range="today"
                                                    className={dateRate === 'today' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    오늘
                                                </li>
                                                <li
                                                    value-date-range="1week"
                                                    className={dateRate === '1week' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    일주일
                                                </li>
                                                <li
                                                    value-date-range="15days"
                                                    className={dateRate === '15days' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    15일
                                                </li>
                                                <li
                                                    value-date-range="1month"
                                                    className={dateRate === '1month' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    1개월
                                                </li>
                                                <li
                                                    value-date-range="3months"
                                                    className={dateRate === '3months' ? 'active' : ''}
                                                    onClick={handleDateRange}
                                                >
                                                    3개월
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>메뉴 표시</th>
                                    <td>
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                onChange={handleChangeDisplay}
                                                checked={display === 'Y'}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="group-button center">
                            <button className="btn btn-gray-bold" onClick={clickSearch}>
                                검색
                            </button>
                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                초기화
                            </button>
                        </div>
                    </div>

                    <div className="result">
                        <div className="before-table">
                            <div className="count-item">
                                총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                            </div>
                            <div className="button-item">
                                <button
                                    data-add="true"
                                    onClick={(e) => {
                                        handlePopupAdd('add');
                                    }}
                                >
                                    서식 등록
                                </button>
                            </div>
                        </div>

                        <table className="table table-gray">
                            <thead>
                                <tr>
                                    <th className="checkbox-all"></th>
                                    <th>구분</th>
                                    <th>서식명</th>
                                    <th>파일</th>
                                    <th>등록일</th>
                                    <th>조회수</th>
                                    <th>다운로드수</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        name="checkDelete"
                                                        className="pointer"
                                                        checked={checkedList.includes(item?.seq)}
                                                        onChange={(e) => handleCheckDelete(item?.seq, e.target.checked)}
                                                    />
                                                </td>
                                                <td>{item?.gubun}</td>
                                                <td>
                                                    <span data-seq={item?.seq} onClick={handlePopupUpdate}>
                                                        {item?.title}
                                                    </span>
                                                </td>
                                                <td className="text-underline">{item?.attachFile}</td>
                                                <td>{formatDate(item?.addDate)}</td>
                                                <td>{item?.visitedCnt}</td>
                                                <td>{item?.downCnt}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={15}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div className="after-table">
                            <div className="button-item">
                                <button data-add="true" onClick={handleDelete}>
                                    선택 삭제
                                </button>
                            </div>
                        </div>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
            {isOpenDocument && (
                <div id="popup" data-popup="dental-plus-preview" className="dental-plus-preview">
                    <div className="overlay" onClick={handleClosePopup} />
                    <div className="popup-content">
                        <div className="popup-close" onClick={handleClosePopup} />
                        <div className="popup-title">문서 서식 등록/수정</div>
                        <div className="table-content">
                            <table className="table-gray table-popup">
                                <tbody>
                                    <tr>
                                        <td colSpan={4}>기본정보</td>
                                    </tr>
                                    <tr>
                                        <th className="border-l-ddd require">
                                            <span>서식명</span>
                                        </th>
                                        <td style={{ width: '40%' }}>
                                            <input
                                                type="text"
                                                onChange={handleChange}
                                                name="title"
                                                value={prepareData.document?.title || ''}
                                            />
                                        </td>
                                        <th className="border-l-ddd border-b-ddd require">
                                            <span>구분</span>
                                        </th>
                                        <td>
                                            <select
                                                name="gubun"
                                                onChange={handleChange}
                                                value={
                                                    prepareData.document?.gubun ||
                                                    (gubunData.length > 0 ? gubunData[0].code : '')
                                                }
                                            >
                                                {gubunData.map((item, index) => (
                                                    <option key={index} value={item?.code}>
                                                        {item?.codeName}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="border-l-ddd require">
                                            <span>파일</span>
                                        </th>
                                        <td>
                                            <div className="group-input-file">
                                                <input
                                                    type="file"
                                                    id="file"
                                                    name="file"
                                                    accept=".doc, .docx, .pdf, .hwp, .xls, .xlsx, .ppt, .pptx, .txt, .zip, .rar"
                                                    placeholder="썸네일 등록"
                                                    onChange={handleFileChange}
                                                    ref={fileInputRef}
                                                    className="custom-input hidden-file-input"
                                                />
                                                <label htmlFor="file" className="custom-label-file">
                                                    파일첨부
                                                </label>
                                            </div>
                                            <div className="result-input-file">
                                                <ul>
                                                    {prepareData.document?.attachFile ||
                                                        (file && (
                                                            <li
                                                                className="file-name"
                                                                onClick={() => handleRemoveFile('file')}
                                                            >
                                                                {file.name || prepareData.document?.attachFile}
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        </td>
                                        <th className="border-l-ddd require">
                                            <span>미리보기</span>
                                        </th>
                                        <td>
                                            <div className="group-input-file">
                                                <input
                                                    type="file"
                                                    id="fileImage"
                                                    placeholder="썸네일 등록"
                                                    name="fileImage"
                                                    onChange={handleFileChange}
                                                    accept="image/*"
                                                    ref={fileImageInputRef}
                                                    className="custom-input hidden-file-input"
                                                />
                                                <label htmlFor="fileImage" className="custom-label-file">
                                                    파일첨부
                                                </label>
                                            </div>
                                            <div className="result-input-file">
                                                <ul>
                                                    {prepareData.document?.prevImg ||
                                                        (fileImage && (
                                                            <li
                                                                className="file-name"
                                                                onClick={() => handleRemoveFile('fileImage')}
                                                            >
                                                                {fileImage.name || prepareData.document?.prevImg}
                                                            </li>
                                                        ))}
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="group-btn">
                            <button className="button-save" onClick={handleSave}>
                                등록/수정
                            </button>
                            <button className="button-back-to-list" onClick={handleClosePopup}>
                                취소
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
export default MAGAD010;
